// extracted by mini-css-extract-plugin
export default {"documentItem":"styles_documentItem__tAgHm","title":"styles_title__wowiD","searchButton":"styles_searchButton__Xz82H"};